// extracted by mini-css-extract-plugin
export default {"dialog":"BdxPerilBreakdownModal_dialog__1NrH-","description":"BdxPerilBreakdownModal_description__iYNJS","rowListToast":"BdxPerilBreakdownModal_rowListToast__eAeZN"};